<template>
  <div class="data-input-holder">
    <div class="data-label">
      {{ data.label }}
    </div>
    <input
    ref="input"
      :id="'di-input-' + data.value"
      v-model.lazy="getInputModel"
      :type="data.field"
      :class="getEditableState"
      :placeholder="data.placeholder"
      @click="selectAll"
    >
    <div v-if="data.label === 'Max Pressure'" class="input-pressure-label">{{ pressureUnit }}</div>
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';
import { useSettingsStore } from '@/store/SettingsStore';
import * as UnitConversion from '@/services/UnitConversionService';

export default {
  name: 'DataInput',
  props: ['data','val'],
  computed: {
    pressureUnit () {
      return useSettingsStore().getPressureUnit;
    },
    getInputModel: {
      get () {
        if (usePipeStore().getEditedPipe === null) {
          return;
        }
        return this.filterUnits(usePipeStore().getEditedPipe[this.$props.data.value]);
      },
      set (value) {
        const pipeStore = usePipeStore();
        if (this.$props.data.value === 'max_pressure_Pa') {
          if (value.length === 0) {
            pipeStore.setEditedPipeValue(this.$props.data.value, 0);
          } else {
            pipeStore.setEditedPipeValue(this.$props.data.value, Math.ceil(UnitConversion.UnfilterPressure(JSON.parse(value), this.pressureUnit)));
          }
        } else if (this.$props.data.value === 'roughness' || this.$props.data.value === 'class') {
          if (value.length === 0) {
            pipeStore.setEditedPipeValue(this.$props.data.value, '');
          } else {
          pipeStore.setEditedPipeValue(this.$props.data.value, JSON.parse(value));
          }
        } else {
          pipeStore.setEditedPipeValue(this.$props.data.value, value);
        }
      }
    },
    getEditableState () {
      const pipeStore = usePipeStore();
      return (pipeStore.getAllowPipeEdit && pipeStore.getPipeModalVisible) ? 'data-input' : 'disable-data-input';
    }
  },
  methods: {   
    selectAll () {
      this.$refs.input.select();
    },
    filterUnits (value) {
      let num;
      switch (this.$props.data.value) {
        case 'max_pressure_Pa':
          num = (UnitConversion.FilterPressure(value, this.pressureUnit)).toFixed(2);
          break;
        default:
          num = value;
      }
      return num;
    },
  }
};
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
.data-input-holder {
  display: flex;
  margin-bottom:14px;
  width: 100%;
  height: 30px;
  font-size: .8em;
  align-items: center;
}
.data-label {
  width: 17%;
  min-width: 75px;
  font-weight: bold;
}
.data-input {
  width: 100%;
  height: 30px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 18px;
  background-color: white;
}
.disable-data-input {
  width: 100%;
  height: 30px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 18px;
  background-color: white;
  border: 1px solid white;
  color: gray;
  pointer-events: none;
}
.input-pressure-label {
  font-weight: bold;
  font-size: 90%;
  padding-left: 10px;
}
</style>